import axios from "axios";
import { toast } from "../utils/toast";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

const TOAST_METHODS = ["post", "put", "delete"];

api.interceptors.response.use(
  (response) => {
    if (
      TOAST_METHODS.includes(response.config?.method) &&
      response.data?.message &&
      !response.config?.skipToast
    ) {
      toast.success(response.data.message);
    }
    return response;
  },
  (error) => {
    const response = error?.response;
    const status = response?.status;
    const message = response?.data?.message;
    const method = error?.config?.method;

    if (status === 401 || status === 403) {
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
        return new Promise(() => {});
      }
      // If already on login page, just reject the promise normally
      return Promise.reject(error);
    }

    if (status === 404) {
      window.location.replace("/not-found");
      return new Promise(() => {});
    }

    if (status === 500) {
      window.location.replace("/server-error");
      return new Promise(() => {});
    }

    if (!response) {
      window.location.replace("/server-error");
      return new Promise(() => {});
    }

    if (TOAST_METHODS.includes(method)) {
      toast.error(message || "Something went wrong", { duration: 1000 });
    }

    return Promise.reject(error);
  }
);

export default api;
